import axios from 'axios'
import type { AxiosResponse } from 'axios'
import type { McpConnection, McpIntegration } from '@/models/Mcp/Types'

const apiUrl = import.meta.env.VITE_API_URL

export default class McpApi {
	async listIntegrations(): Promise<AxiosResponse<{ data: McpIntegration[] }>> {
		return await axios.get(`${apiUrl}/mcp/integrations`)
	}

	async listConnections(): Promise<AxiosResponse<{ data: McpConnection[] }>> {
		return await axios.get(`${apiUrl}/mcp/connections`)
	}

	async disconnectConnection(
		clientId: string,
	): Promise<AxiosResponse<{ message: string; revoked_tokens: number }>> {
		return await axios.post(`${apiUrl}/mcp/connections/${clientId}/disconnect`)
	}

	async revokeConnectionToken(
		clientId: string,
		tokenId: string,
	): Promise<AxiosResponse<{ message: string }>> {
		return await axios.delete(`${apiUrl}/mcp/connections/${clientId}/tokens/${tokenId}`)
	}
}
